module.exports = __webpack_public_path__ + "img/shg.2586056f.jpg";